import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

interface ExchangeParams {
  /** The authorization code from Amazon OAuth callback */
  amazon_authorization_code: string;
  /** Whether this is for adding additional Amazon Ads credentials */
  additional_ads_credentials?: boolean;
  /** Whether this is for reauthorizing existing credentials */
  reauthorize?: boolean;
}

/**
 * Hook for exchanging Amazon Advertising OAuth authorization code for access tokens.
 * Uses TanStack Query mutation for handling the async POST request.
 *
 * The backend exchanges the code with Amazon, stores the tokens, and updates onboarding status.
 */
export function useAmazonAdvertisingOAuthExchange() {
  return useMutation({
    mutationFn: async ({ amazon_authorization_code, additional_ads_credentials, reauthorize }: ExchangeParams) => {
      return await apiClient.exchangeAmazonAdvertisingCode(
        { amazon_authorization_code },
        {
          queries: {
            additional_ads_credentials,
            reauthorize,
          },
        },
      );
    },
  });
}
